<template>
  <MoleculeFloatingButton/>
</template>

<script>
export default {
  name: 'OrganismFloatingButton',

  components: {
    MoleculeFloatingButton: () => import('@/components/molecules/MoleculeFloatingButton')
  }
}
</script>
